const mapOnboardingIntroChatMessagesForApi = (messages = []) => {
  return (Array.isArray(messages) ? messages : [])
    .map((message) => {
      return {
        role: String(message?.role || '').trim(),
        content: String(message?.content || '').trim()
      };
    })
    .filter((message) => {
      return Boolean(message.role && message.content);
    });
};

export default mapOnboardingIntroChatMessagesForApi;
